import * as angular from "angular";
import * as moment from "moment";
import * as _ from "lodash";
import {apsCommands} from "../../shared/dto/aps.commands";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";

import {Endpoints} from "../../shared/config/constant.module";
import HttpServiceName, {HttpService} from "../http/http.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import LineSheetServiceName, {LineSheetService} from "../lineSheet/lineSheet.service";
import AddToolChangeName, {openAddToolChange} from "../../controllers/toolChange/addToolChange.controller";
let requires = ['mm.foundation', HttpServiceName, LoaderServiceName, LineSheetServiceName, AddToolChangeName];

export interface SectionChangeLookup {
  sectionChangeId: string;
  sectionChangeSectionId: string;
  shopId: string;
  isMachineId: string;
  section: number;
}

export interface SectionChangeService {
  openToolChangeForSectionChange(lookupData: SectionChangeLookup): void;
  skipSectionChange(command: apsCommands.SkipSectionChangeSection): angular.IPromise<any>;
  getStrategies(): angular.IPromise<apsViewModels.SectionChangeStrategyDetail[]>;
  getStrategy(id: string): angular.IPromise<apsViewModels.SectionChangeStrategyDetail>;
  getStrategiesForShop(shop: apsViewModels.ShopNavigation): angular.IPromise<apsViewModels.SectionChangeStrategyDetail[]>;
  addUpdateStrategy(command: apsCommands.AddUpdateSectionChangeStrategy): angular.IPromise<any>;
  deleteStrategy(id: string): angular.IPromise<any>;
  copyStrategy(command: apsCommands.CopySectionChangeStrategy): angular.IPromise<any>;
}

class SectionChangeServiceImpl implements SectionChangeService {

  private lineSheetService: LineSheetService;
  private $modal: mm.foundation.modal;
  private loaderService: LoaderService;
  private httpService: HttpService;

  constructor(lineSheetService: LineSheetService,
              loaderService: LoaderService,
              httpService: HttpService,
              $modal: mm.foundation.modal) {
    this.lineSheetService = lineSheetService;
    this.loaderService = loaderService;
    this.$modal = $modal;
    this.httpService = httpService;
  }

  openToolChangeForSectionChange(lookupData: SectionChangeLookup): void {
    let lineSheetPromise = this.lineSheetService.getLineSheetActivity(lookupData.shopId, moment());
    this.loaderService.loadingPromise(lineSheetPromise);

    lineSheetPromise.then(data => {
      let machine = _.find(data.machines, {id: lookupData.isMachineId});
      let section = _.find(machine.sections, {sectionNumber: lookupData.section});
      let gob = section.gobs[0];
      openAddToolChange({
        shopId: lookupData.shopId,
        activity: data,
        gob: gob,
        gobHour: gob.hours[0],
        date: new Date(),
        sectionChangeId: lookupData.sectionChangeId,
        sectionChangeSectionId: lookupData.sectionChangeSectionId
      }, this.$modal);
    });
  }

  skipSectionChange(command: apsCommands.SkipSectionChangeSection): angular.IPromise<any> {
    return this.httpService.put(Endpoints.SECTION_CHANGE_SKIP, command);
  }

  getStrategies(): angular.IPromise<apsViewModels.SectionChangeStrategyDetail[]> {
    return this.httpService.get<apsViewModels.SectionChangeStrategyDetail[]>(Endpoints.SECTION_CHANGE_STRATEGY);
  }

  getStrategy(id: string): angular.IPromise<apsViewModels.SectionChangeStrategyDetail> {
    return this.httpService.get<apsViewModels.SectionChangeStrategyDetail>(Endpoints.SECTION_CHANGE_STRATEGY + '/' + id);
  }

  getStrategiesForShop(shop: apsViewModels.ShopNavigation): angular.IPromise<apsViewModels.SectionChangeStrategyDetail[]> {
    return this.getStrategies().then(data => {
      return _.filter(data, (s: apsViewModels.SectionChangeStrategyDetail) =>
        s.plantId === null || (s.plantId === shop.plantId && (s.shopId === null || s.shopId === shop.id)));
    });
  }

  addUpdateStrategy(command: apsCommands.AddUpdateSectionChangeStrategy): angular.IPromise<any> {
    return this.httpService.post(Endpoints.SECTION_CHANGE_STRATEGY, command);
  }

  deleteStrategy(id: string): angular.IPromise<any> {
    return this.httpService.delete(Endpoints.SECTION_CHANGE_STRATEGY + '/' + id);
  }

  copyStrategy(command: apsCommands.CopySectionChangeStrategy): angular.IPromise<any> {
    return this.httpService.put(Endpoints.SECTION_CHANGE_STRATEGY, command);
  }
}

export default angular
    .module('aps.services.sectionChange', requires)
    .service('sectionChangeService', SectionChangeServiceImpl)
    .name;


// WEBPACK FOOTER //
// ./src/app/services/toolChange/sectionChange.service.ts